import { c as _c } from "react/compiler-runtime";
import { Box, FormSummary } from "@navikt/ds-react";
import type { OppfolgingsplanFormUtfyllt } from "@/schema/oppfolgingsplanForm/formValidationSchemas";
import { getFormattedDateString } from "@/ui-helpers/dateAndTime";
import { formHeadings, formLabels } from "../form-labels";
interface Props {
  formValues: OppfolgingsplanFormUtfyllt;
  onEditPlan: () => void;
  className?: string;
}
export default function PlanFormSummary(t0) {
  const $ = _c(50);
  const {
    formValues,
    className
  } = t0;
  let t1;
  if ($[0] !== formValues.evalueringsDato) {
    t1 = formValues.evalueringsDato ? getFormattedDateString(formValues.evalueringsDato) : <em>Ikke valgt</em>;
    $[0] = formValues.evalueringsDato;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const evalueringsDatoFormatted = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <FormSummary.Header><FormSummary.Heading level="3">{formHeadings.arbeidsoppgaver}</FormSummary.Heading></FormSummary.Header>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FormSummary.Label>{formLabels.typiskArbeidshverdag.label}</FormSummary.Label>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== formValues.typiskArbeidshverdag) {
    t4 = <FormSummary.Answer>{t3}<FormSummary.Value>{formValues.typiskArbeidshverdag}</FormSummary.Value></FormSummary.Answer>;
    $[4] = formValues.typiskArbeidshverdag;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FormSummary.Label>{formLabels.arbeidsoppgaverSomKanUtfores.label}</FormSummary.Label>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== formValues.arbeidsoppgaverSomKanUtfores) {
    t6 = <FormSummary.Answer>{t5}<FormSummary.Value>{formValues.arbeidsoppgaverSomKanUtfores}</FormSummary.Value></FormSummary.Answer>;
    $[7] = formValues.arbeidsoppgaverSomKanUtfores;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FormSummary.Label>{formLabels.arbeidsoppgaverSomIkkeKanUtfores.label}</FormSummary.Label>;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== formValues.arbeidsoppgaverSomIkkeKanUtfores) {
    t8 = <FormSummary.Answer>{t7}<FormSummary.Value>{formValues.arbeidsoppgaverSomIkkeKanUtfores}</FormSummary.Value></FormSummary.Answer>;
    $[10] = formValues.arbeidsoppgaverSomIkkeKanUtfores;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t6 || $[14] !== t8) {
    t9 = <FormSummary className="mb-8 whitespace-pre-line">{t2}<FormSummary.Answers>{t4}{t6}{t8}</FormSummary.Answers></FormSummary>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FormSummary.Header><FormSummary.Heading level="3">{formHeadings.tilrettelegging}</FormSummary.Heading></FormSummary.Header>;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <FormSummary.Label>{formLabels.tidligereTilrettelegging.label}</FormSummary.Label>;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] !== formValues.tidligereTilrettelegging) {
    t12 = <FormSummary.Answer>{t11}<FormSummary.Value>{formValues.tidligereTilrettelegging}</FormSummary.Value></FormSummary.Answer>;
    $[18] = formValues.tidligereTilrettelegging;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <FormSummary.Label>{formLabels.tilretteleggingFremover.label}</FormSummary.Label>;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== formValues.tilretteleggingFremover) {
    t14 = <FormSummary.Answer>{t13}<FormSummary.Value>{formValues.tilretteleggingFremover}</FormSummary.Value></FormSummary.Answer>;
    $[21] = formValues.tilretteleggingFremover;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <FormSummary.Label>{formLabels.annenTilrettelegging.label}</FormSummary.Label>;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== formValues.annenTilrettelegging) {
    t16 = <FormSummary.Answer>{t15}<FormSummary.Value>{formValues.annenTilrettelegging}</FormSummary.Value></FormSummary.Answer>;
    $[24] = formValues.annenTilrettelegging;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <FormSummary.Label>{formLabels.hvordanFolgeOpp.label}</FormSummary.Label>;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== formValues.hvordanFolgeOpp) {
    t18 = <FormSummary.Answer>{t17}<FormSummary.Value>{formValues.hvordanFolgeOpp}</FormSummary.Value></FormSummary.Answer>;
    $[27] = formValues.hvordanFolgeOpp;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <FormSummary.Label>{formLabels.evalueringsDato.label}</FormSummary.Label>;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  let t20;
  if ($[30] !== evalueringsDatoFormatted) {
    t20 = <FormSummary.Answer>{t19}<FormSummary.Value>{evalueringsDatoFormatted}</FormSummary.Value></FormSummary.Answer>;
    $[30] = evalueringsDatoFormatted;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  let t21;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <FormSummary.Label>{formLabels.harDenAnsatteMedvirket.label}</FormSummary.Label>;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  const t22 = formValues.harDenAnsatteMedvirket === "ja" ? "Ja" : "Nei";
  let t23;
  if ($[33] !== t22) {
    t23 = <FormSummary.Answer>{t21}<FormSummary.Value>{t22}</FormSummary.Value></FormSummary.Answer>;
    $[33] = t22;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== formValues.denAnsatteHarIkkeMedvirketBegrunnelse || $[36] !== formValues.harDenAnsatteMedvirket) {
    t24 = formValues.harDenAnsatteMedvirket === "nei" && <FormSummary.Answer><FormSummary.Label>{formLabels.denAnsatteHarIkkeMedvirketBegrunnelse.label}</FormSummary.Label><FormSummary.Value>{formValues.denAnsatteHarIkkeMedvirketBegrunnelse}</FormSummary.Value></FormSummary.Answer>;
    $[35] = formValues.denAnsatteHarIkkeMedvirketBegrunnelse;
    $[36] = formValues.harDenAnsatteMedvirket;
    $[37] = t24;
  } else {
    t24 = $[37];
  }
  let t25;
  if ($[38] !== t12 || $[39] !== t14 || $[40] !== t16 || $[41] !== t18 || $[42] !== t20 || $[43] !== t23 || $[44] !== t24) {
    t25 = <FormSummary>{t10}<FormSummary.Answers>{t12}{t14}{t16}{t18}{t20}{t23}{t24}</FormSummary.Answers></FormSummary>;
    $[38] = t12;
    $[39] = t14;
    $[40] = t16;
    $[41] = t18;
    $[42] = t20;
    $[43] = t23;
    $[44] = t24;
    $[45] = t25;
  } else {
    t25 = $[45];
  }
  let t26;
  if ($[46] !== className || $[47] !== t25 || $[48] !== t9) {
    t26 = <Box className={className}>{t9}{t25}</Box>;
    $[46] = className;
    $[47] = t25;
    $[48] = t9;
    $[49] = t26;
  } else {
    t26 = $[49];
  }
  return t26;
}